import { axiosInventoryInstance } from '@/config/apiConfig';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { IQuickPayMasterProduct } from '@/store/sagas/quickPaySaga';
import { AxiosResponse } from 'axios';

// Define the User interface representing the structure of the user object returned by the API
interface IUser {
  id: string;
  // ... other properties of the user object
}
interface IDeleteQuickPayMasterProduct {
  id: string;
}

export interface IFetchQuickPayMasterProduct {
  page?: number;
  limit?: number;
  name?: string;
  barcode?: string;
  pepsiProductId?: string;
  createdEndDate?: string;
  createdStartDate?: string;
  orderBy?: string;
  order?: string;
  includeInactive?: boolean;
  inactive?: boolean;
}

export const fetchQuickPayMasterProducts = ({
  page,
  limit,
  name,
  barcode,
  pepsiProductId,
  createdEndDate,
  createdStartDate,
  orderBy,
  order,
  includeInactive,
  inactive,
}: IFetchQuickPayMasterProduct): Promise<
  AxiosResponse<IFetchQuickPayMasterProduct, any>
> => {
  return axiosInventoryInstance({
    url: `${API_URL_CONFIG.QUICK_PAY_MASTER_PRODUCT.GET_ALL_MASTER_PRODUCTS}`,
    method: 'GET',
    params: {
      page,
      limit,
      ...(name && name.length > 0 ? { name } : {}),
      ...(barcode && barcode.length ? { barcode } : {}),
      ...(pepsiProductId && pepsiProductId.length ? { pepsiProductId } : {}),
      ...(createdEndDate && createdEndDate.length ? { createdEndDate } : {}),
      ...(createdStartDate && createdStartDate.length
        ? { createdStartDate }
        : {}),
      includeInactive,
      inactive,
      orderBy,
      order,
    },
  });
};

export const fetchQuickPayMasterProduct = (
  id: number,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.get(
    `${API_URL_CONFIG.QUICK_PAY_MASTER_PRODUCT.GET_ALL_MASTER_PRODUCTS}/${id}`,
  );
};

export const createQuickPayMasterProduct = (
  payload: IQuickPayMasterProduct,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.post(
    `${API_URL_CONFIG.QUICK_PAY_MASTER_PRODUCT.GET_ALL_MASTER_PRODUCTS}`,
    payload,
  );
};

export const updateQuickPayMasterProduct = (
  id: string,
  payload: IQuickPayMasterProduct,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.QUICK_PAY_MASTER_PRODUCT.GET_ALL_MASTER_PRODUCTS}/${id}`,
    payload,
  );
};

export const deleteQuickPayMasterProduct = (
  id: string,
): Promise<AxiosResponse<IDeleteQuickPayMasterProduct, any>> => {
  return axiosInventoryInstance.delete(
    `${API_URL_CONFIG.QUICK_PAY_MASTER_PRODUCT.GET_ALL_MASTER_PRODUCTS}/${id}`,
  );
};
